import React from "react";

export interface ExpenseThisMonthInsightItem {
  title: string;
  description: string;
  accentColor?: "success" | "neutral" | "warning";
}

export interface ExpenseThisMonthInsightsPanelProps {
  monthLabel?: string;
  insights: ExpenseThisMonthInsightItem[];
  loading?: boolean;
}

const barClass: Record<
  NonNullable<ExpenseThisMonthInsightItem["accentColor"]>,
  string
> = {
  success: "bg-success-500",
  neutral: "bg-neutral-300",
  warning: "bg-warning-500",
};

export function ExpenseThisMonthInsightsPanel({
  monthLabel = "February · Insights",
  insights,
  loading = false,
}: ExpenseThisMonthInsightsPanelProps) {
  if (loading) {
    return (
      <div className="flex flex-col items-start gap-4 flex-1 min-w-0">
        <div className="h-4 w-28 animate-pulse rounded bg-neutral-200" />
        {[1, 2].map((i) => (
          <div
            key={i}
            className="flex w-full gap-4 rounded-lg border border-solid border-neutral-100 bg-neutral-50 px-4 py-4 min-h-[60px] animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start gap-4 flex-1 min-w-0">
      <span className="text-caption-bold font-caption-bold text-neutral-400 uppercase tracking-widest">
        {monthLabel}
      </span>
      {insights.map((item, i) => (
        <div
          key={i}
          className="flex w-full gap-4 rounded-lg border border-solid border-neutral-100 bg-neutral-50 px-4 py-4 items-stretch"
        >
          <div
            className={`flex w-1 flex-none flex-col items-start rounded-full ${barClass[item.accentColor ?? "neutral"]}`}
          />
          <div className="flex flex-col items-start gap-1 flex-1">
            <span className="text-caption-bold font-caption-bold text-neutral-400 uppercase tracking-wider">
              {item.title}
            </span>
            <span className="text-body font-body text-neutral-700">
              {item.description}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
